export enum SystemMessageType {
  RECEIVE_MATCHING_REQUEST = 'receive_matching_request',
  SENT_MATCHING_REQUEST = 'sent_matching_request',
  RESPONSE_MATCHING_REQUEST_BUTTON = 'response_matching_request_button',
  ACCEPT_MATCHING_REQUEST = 'accept_matching_request',
  REJECT_MATCHING_REQUEST = 'reject_matching_request',
}

export const SystemMessageTypeLabel = {
  [SystemMessageType.RECEIVE_MATCHING_REQUEST]: 'マッチングリクエスト受信',
  [SystemMessageType.SENT_MATCHING_REQUEST]: 'マッチングリクエスト送信',
  [SystemMessageType.RESPONSE_MATCHING_REQUEST_BUTTON]:
    'マッチングリクエスト承否ボタン',
  [SystemMessageType.ACCEPT_MATCHING_REQUEST]: 'マッチングリクエスト承認',
  [SystemMessageType.REJECT_MATCHING_REQUEST]: 'マッチングリクエスト拒否',
}

export type SystemMessageTypeValue =
  (typeof SystemMessageType)[keyof typeof SystemMessageType]
